import { ApiCodeGenerationEventName } from 'sprites-types/api/codegen'

// Convert from event names to user facing messages, which cycle through possible messages.
export const eventNameToUserFacingMessageMap: Record<ApiCodeGenerationEventName, string[]> = {
  app_metadata_generated: [
    'Creating app metadata',
    'Compiling app details',
    'Documenting app information',
  ],
  code_generation_planning: [
    'Breaking it down into manageable steps',
    'Charting the course ahead',
    'Coming up with a game plan',
    'Creating a solid foundation',
    'Figuring out the best way to start',
    'Getting our ducks in a row',
    'Lining up all the right pieces',
    'Mapping out the next steps',
    'Outlining the key objectives',
    'Planning our approach carefully',
    'Sketching out the blueprint',
    'Strategizing the implementation',
  ],
  code_generation_rag: [
    'Doing a little research',
    'Gathering everything we need',
    'Selecting the best tools to use',
    "Making sure we're on the right track",
  ],
  code_generation: [
    'Assembling the building blocks',
    'Breathing life into concepts',
    'Bringing ideas to life',
    'Building piece by piece',
    'Constructing bit by bit',
    'Cooking up something awesome',
    'Crafting digital solutions',
    'Engineering the future',
    'Forging new possibilities',
    'Letting the creativity flow',
    'Making something out of nothing',
    'Putting the gears in motion',
    'Sculpting with code',
    'Shaping code into form',
    'Transforming vision into code',
    'Turning thoughts into reality',
    'Weaving everything together',
    'Working some behind-the-scenes magic',
  ],
  code_generation_evaluation: [
    'Checking to make sure everything works',
    'Fine-tuning the results',
    'Giving it a once-over',
    'Making sure the details are just right',
    "Dotting the i's and crossing the t's",
  ],
  code_generation_dependencies: [
    'Getting all the required components',
    'Making sure we have everything we need',
    'Picking up some missing puzzle pieces',
    'Stocking up on supplies',
  ],
  code_generation_steps_yaml: [
    'Breaking it down into simple pieces',
    'Creating clear instructions',
    'Documenting the key steps',
    'Making it clear and straightforward',
    'Mapping out the workflow',
    'Organizing the information clearly',
    'Putting together a simple guide',
    'Sketching out the game plan',
    'Writing up some handy notes',
  ],
  code_generation_merge: [
    'Bringing all the pieces into place',
    'Making sure it all fits perfectly',
    'Mixing everything together',
    'Tying up the loose ends',
  ],
  code_generation_memory: [
    'Keeping track of all the progress',
    'Making sure nothing gets lost',
    'Keeping track of our progress so far',
  ],
  upload_code: [
    'Getting ready for transport',
    'Packing it up and sending it off',
    'Preparing the delivery package',
    'Saving everything in a safe place',
    'Securing your creation',
    'Uploading your hard work',
  ],
  deployment: [
    'Bringing it to life for everyone',
    'Getting ready for takeoff',
    'Getting set for prime time',
    'Launching into the world',
    'Making it available to all',
    'Making it official',
    'Opening the doors wide',
    'Preparing for the big moment',
    'Putting everything in place',
    'Rolling out the welcome mat',
    'Setting the stage for success',
    'Unleashing it into the wild',
  ],
}
